module.exports = __webpack_public_path__ + "02_glasses_blue.6c276668.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/02_glasses_blue.png
// module id = M5o/
// module chunks = 0